import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Globe icon for representing countries or global concepts
 */
export const GlobeIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="2" y1="12" x2="22" y2="12"></line>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </Icon>
  );
};

export default GlobeIcon;
